import React from 'react'
import {Icon} from '@chakra-ui/react'

const EcoPartIcon = (props) => {
    return (
        <Icon viewBox="0 0 12 12" fill="none" data-testid="eco-part-icon" {...props}>
            <g clipPath="url(#eco-part-clip)">
                <path
                    d="M5.49987 10C4.6219 10.0027 3.77499 9.67525 3.12713 9.08271C2.47926 8.49017 2.07775 7.67577 2.00224 6.80105C1.92672 5.92633 2.18271 5.05518 2.71944 4.36037C3.25617 3.66556 4.03443 3.19785 4.89987 3.05C7.74987 2.5 8.49987 2.24 9.49987 1C9.99987 2 10.4999 3.09 10.4999 5C10.4999 7.75 8.10987 10 5.49987 10Z"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M1 10.5C1 9 1.925 7.82 3.54 7.5C4.75 7.26 6 6.5 6.5 6"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="eco-part-clip">
                    <rect width="12" height="12" fill="white" />
                </clipPath>
            </defs>
        </Icon>
    )
}

export default EcoPartIcon
